import { render, staticRenderFns } from "./NewReturnsArea.vue?vue&type=template&id=adb1f648&scoped=true&"
import script from "./NewReturnsArea.vue?vue&type=script&lang=js&"
export * from "./NewReturnsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb1f648",
  null
  
)

export default component.exports